module.exports = __webpack_public_path__ + "static/media/multi-how-it-looks.35d7dd2f.png";